import { ReactNode } from "react"
import AppLayout from "@/layouts/AppLayout"
import AdminNavigation from "@/components/admin/AdminNavigation"
import DashboardTopbar from "@/components/DashboardTopbar"
import { usePage } from "@inertiajs/react"
import { AdminEmbedProps } from "@/types/types"
import Card from "@/components/Card"
import { BarList } from "@tremor/react"

export const chartSettings = {
  xAxis: [
    {
      dataKey: "date",
      tickLabelStyle: { display: "none" },
      disableTicks: true,
      disableLine: true,
    },
  ],
  yAxis: [
    {
      tickLabelStyle: { fontSize: 12, fill: "#6b7280" },
      disableLine: true,
      disableTicks: true,
    },
  ],
  grid: {
    horizontal: true,
  },
  margin: { left: 0, right: 0, bottom: 0 },
  hideLegend: true,
}

const AdminEmbedPage = () => {
  const { total_opens_last_30, top_hosts_last_30, top_games_last_30 } =
    usePage<AdminEmbedProps>().props

  return (
    <>
      <DashboardTopbar title="Admin" />
      <AdminNavigation />

      <div className="padding grid w-full max-w-7xl gap-6 py-4 sm:py-6 lg:grid-cols-2 lg:py-8">
        <Card title="Total opens (Last 30 days)" value={total_opens_last_30} />
        <div />
        <Card title="Top hosts (Last 30 days)" value={null}>
          <BarList data={top_hosts_last_30} />
        </Card>

        <Card title="Top games (Last 30 days)" value={null}>
          <BarList data={top_games_last_30} className="h-full w-full" />
        </Card>
      </div>
    </>
  )
}

export default AdminEmbedPage

AdminEmbedPage.layout = (page: ReactNode) => <AppLayout>{page}</AppLayout>
